import { CommonUtilities } from '../../commonUtils';

export default class matchingService {

 static myArrayMain = [
        "Code", "External ID", "Name", "Description", "Category", "Type", "Currency"
];

 static myArrayMap = [
        "Number", "External ID*", "Name*", "Description", "Category", "Type", "Currency"
];

 static myArrayExternal = [
        "Entity Name", "Sync type", "MiscBox1099"
];


/*
    static getTemplateHeaders() {
        //var arr = [ 'this is line #1','this is line #2','this is line #3' ]
        return arr;
    }
 */
}